<template>
  <div class='h-dialogContainer'>
    <div class='h-subscriber-inputLit'>{{$t('SubscriberIms.userNo')}}:</div>
    <ejs-textbox :value='obj.impu' v-model='obj.impu'></ejs-textbox>
    <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.userName')}}:</div>
    <ejs-textbox :value='obj.username' v-model='obj.username'></ejs-textbox>
  </div>
</template>

<script>
export default {
  name: 'ImsUserSearchDialog',
  data() {
    return {
      obj: {
        impu: this.impu === undefined ? '' : this.impu,
        username: this.username === undefined ? '' : this.username,
        userenable:-1,
        rtttype:-1,
        flag: 2
      }
    };
  },
  methods: {
    getFormValue() {
      return { impu: this.obj.impu, username: this.obj.username, userenable: -1, rtttype: -1, flag: 2 };
    },
    getData() {
      return this.obj;
    },
    setData(data = undefined) {
      if (data !== undefined) {
        this.obj = data;
      }
    }
  }
};
</script>

<style scoped>

</style>
